import React from 'react'
import Hero from './Hero'
import Newsletter from './Newsletter'
import Analytics from './Analytics'
import Cards from './Cards'

const Home = () => {
  return (
    <div>
      <Hero/>
      <Analytics/>
      <Cards/>
      <Newsletter/>
    </div>
  )
}

export default Home
